const antdLightTheme = {
	colorPrimary: "#168cfe",
	colorError: "#ff0000",
	colorBorder: "#00000014",
};

const antdDarkTheme = {
	colorPrimary: "#168cfe",
	colorError: "#ff0000",
	colorBorder: "#00000014",
};

export const antdTheme = {
	light: antdLightTheme,
	dark: antdDarkTheme,
};
